import { useContext } from 'react'
import styled from 'styled-components'
import CreationToolSuperCutField from '../../../types/super-cut-field'
import { CreationCaptureInfoContext } from '../../supercut/shared/components/capture-info/manager'
import Toggle from '../../toggle'
import FieldTitle from './field-title'

const Container = styled.div`
    grid-column: span 1;
    min-width: 0;
`

type Props = {
    field: CreationToolSuperCutField
}

const CreationCaptureAutoCropField = ({ field }: Props) => {
    const { autoCrop, setAutoCrop } = useContext(CreationCaptureInfoContext)

    const toggleAutoCrop = () => {
        setAutoCrop(!autoCrop)
    }

    return (
        <Container>
            <FieldTitle field={field} />
            <Toggle isOn={autoCrop} onToggle={toggleAutoCrop} />
        </Container>
    )
}

export default CreationCaptureAutoCropField
